<script setup lang="ts">
// interface
interface Props {
  item?: any;
  bind?: any;
  baseUrl?: string;
}

interface Emits {
  (e: "removeUser", item: any): void;
}

// props
const props = defineProps<Props>();

// emit
const emit = defineEmits<Emits>();
</script>

<template>
  <VChip
    v-bind="props?.bind"
    :prepend-avatar="
      props?.item.raw.avatar
        ? `${props?.baseUrl}/api/files/_pb_users_auth_/${props?.item.raw.id}/${props?.item.raw.avatar}`
        : `https://ui-avatars.com/api/?name=${
            (props?.item.raw.firstName
              ? props?.item.raw.firstName.charAt(0)
              : '') +
              (props?.item.raw.lastName
                ? props?.item.raw.lastName.charAt(0)
                : '') ||
            (props?.item.raw.username ? props?.item.raw.username.charAt(0) : '')
          }&background=${
            props?.item?.raw?.color
              ? props?.item?.raw?.color.replace('#', '')
              : 'fff'
          }`
    "
    @click:close="emit('removeUser', $event)"
  >
    {{
      props?.item.raw.firstName && props?.item.raw.lastName
        ? `${props?.item.raw.firstName} ${props?.item.raw.lastName}`
        : props?.item.raw.username
    }}
  </VChip>
</template>
